function updateItemCount(){
  //const itemCount = event.detail.cart.itemCount();
  if(window.Rebuy.SmartCart.cart){
    const itemCount = (window.Rebuy.SmartCart.cart.item_count) ? window.Rebuy.SmartCart.cart.item_count : '';
    if(document.querySelector('.rebuy-cart__flyout-header .rebuy-cart-count')) document.querySelector('.rebuy-cart__flyout-header .rebuy-cart-count').innerHTML = `(${itemCount})`; 
    if(document.querySelector('[data-cart-item-count]')) document.querySelector('[data-cart-item-count]').innerHTML = `${itemCount}`;
  }
}

document.addEventListener('rebuy:cart.ready', async (event) => {
  const cart = event.detail.cart;
  let logoContainer = document.querySelector('#payment-logos');
  if (!logoContainer) {
    logoContainer = document.createElement('div');
    logoContainer.setAttribute('id', 'payment-logos');
    logoContainer.classList.add('payment-logos');
    const html = document.querySelector('.footer-group .payment-types').innerHTML;
    logoContainer.innerHTML = html;
    const cartFooter = document.querySelector('.rebuy-cart__flyout-footer');
    if(cartFooter) cartFooter.appendChild(logoContainer);
  }

  await updateSmartCartLanguage();
  setTimeout(updateRemaining, 0);

  setTimeout(() => {
    updateItemCount();
  }, 500);

});


document.addEventListener('rebuy:cart.change', (event) => {
  setTimeout(() => {
    updateItemCount();
    updatePrices(event);
  }, 500);
});

async function updatePrices(event) {
  const blocks = document.querySelector('#rebuy-cart [data-smartcart-items]');
  const products = event.detail.cart.cart.items;
  let total_discount = 0;
  total_discount = event.detail.cart.cart.total_discount;
  let index = 0;
  if(blocks != null){
  const variants = await getVariants();
    [...products].map((product) => {
      const listItem = blocks.querySelector(`li[data-variant="${product.variant_id}"]`);
      const price = listItem.getAttribute(`data-price`);
      let variantData = variants.data.filter(variant => variant.id == listItem.getAttribute(`data-variant`));
      const compare_at = variantData[0].compare_at_price;
      //Update compare at price
      if(compare_at != null && compare_at != 0){
        listItem.querySelector(`.rebuy-money.compare-at span:not(.sr-only)`).innerText = window.Rebuy.SmartCart.formatMoney(compare_at, window.theme.moneyFormat);
        total_discount = total_discount + (Math.abs(compare_at - price) * listItem.getAttribute(`data-quantity`));
      } 
      //Update discount tag
      let discount = '';
      if(price < compare_at){
        discount = Math.round(((compare_at - price)/compare_at) * 100);
      }
      if(listItem.querySelector(`.tags .discount.active`)) listItem.querySelector(`.tags .discount`).innerText = `${discount}% OFF`;
      //Update discount in minicart footer
      if(index == [...products].length-1){
        if(total_discount > 0) {
          document.querySelector('#rebuy-cart .rebuy-cart__flyout-discount-amount').innerText = `-${window.Rebuy.SmartCart.formatMoney(total_discount, window.theme.moneyFormat)}`;
          document.querySelector('#rebuy-cart .rebuy-cart__flyout-discount').removeAttribute('hidden');
        }else {
          document.querySelector('#rebuy-cart .rebuy-cart__flyout-discount').setAttribute('hidden','');
        }
      }
      index++;
    });
  }
}

async function getSubTitle(item) {
    const response = await fetch(`${window.Shopify.routes.root}products/${item.handle}?view=subtitle`);
    const data = await response.json();
    return {
      'response' : response,
        'data': data 
    };
}

async function getVariants(handle) {
  //const response = await fetch(`${window.Shopify.routes.root}products/${handle}?view=variants`);
  const response = await fetch(`${window.Shopify.routes.root}cart?view=items`);
  const data = await response.json();
  return {
    'response' : response,
      'data': data 
  };
}

document.addEventListener('rebuy:smartcart.init', (event) => {

  window.Rebuy.SmartCart.itemObject = function (item) {
    object = JSON.stringify(item);
    return object;
  };

  window.Rebuy.SmartCart.discountFlag = function (item) {
    let discount = '';
    let classes = '';
    let multiplier = (Shopify.currency.active == "EUR") ? 1 : 100;
    const compare_at = window.Rebuy.SmartCart.compareAtPrice(item) * multiplier;
    const price = window.Rebuy.SmartCart.itemPrice(item);
    if(price < compare_at){
      discount = Math.round(((compare_at - price)/compare_at) * 100) + '% OFF';
      classes = 'active';
    }
    return classes;
  };

  window.Rebuy.SmartCart.customSubTitle = function (item) {

    let tags = window.Rebuy.SmartCart.itemProductTagsClasses(item);
    let subTitle = '';
    tags = tags.match(/tag-subtitle_([\w'-]+)/);
    if(tags) {
      subTitle = tags[0].replace('tag-subtitle_','')
      subTitle = subTitle.replace('-',' ');
    } 
    return subTitle;
  };

  window.Rebuy.SmartCart.showDiscountTotal = function(){
    return (window.Rebuy.SmartCart.cart.total_discount > 0) ? true : false;
  };

  window.Rebuy.SmartCart.customDiscountTotal = function(){
    return `-${window.Rebuy.SmartCart.formatMoney(window.Rebuy.SmartCart.cart.total_discount, window.theme.moneyFormat)}`;
  };

  window.Rebuy.SmartCart.customSubTotal = function () {
    return window.Rebuy.SmartCart.formatMoney(window.Rebuy.SmartCart.cart.total_price, window.theme.moneyFormat);
  };

});

function addSubTitles() {
  const blocks = document.querySelectorAll('.rebuy-product-block');
  [...blocks].map((block) => {
      let tags = block.classList.toString().match(/tag-subtitle_([\w'-]+)/);
      let subTitle= '';
      if(tags) {
        subTitle = tags[0].replace('tag-subtitle_','')
        subTitle = subTitle.replace('-',' ');
      } 
      if(block.querySelector('.subtitle')) block.querySelector('.subtitle').innerHTML = subTitle;
  });
}

function decodeString(str){
  var parser = new DOMParser;
  var dom = parser.parseFromString(
    '<!doctype html><body>' + str,
    'text/html');
  return dom.body.textContent;
}

function setWidgetTitle() {
  const lang = JSON.parse(rebuyLang);
  //Update title
  if(!!lang.minicart_recommendations.title && document.querySelector('.rebuy-cart__flyout-recommendations .rebuy-widget .primary-title')) document.querySelector('.rebuy-cart__flyout-recommendations .rebuy-widget .primary-title').innerHTML = decodeString(lang.minicart_recommendations.title);
  if(!!lang.pdp_bundle.title && document.querySelector('#rebuy-widget-149274 .primary-title')) document.querySelector('#rebuy-widget-149274 .primary-title').innerHTML = decodeString(lang.pdp_bundle.title);
}

function addBundle(event){
  console.log(`add bundle`);
 // "149274"
 console.log(`event: `,event);
  console.log(`event.detail.widget.id: `,event.detail.widget.id);
}

document.addEventListener('rebuy.ready', function(event){
  addSubTitles();
  setWidgetTitle();
});

document.addEventListener('rebuy.add', function(event){
  addSubTitles();
  //addBundle(event);
});

// Update widgets with locale translations
document.addEventListener('rebuy.ready', (event) => {
  const widget = event.detail.widget;
  updateWidgetLanguage(widget);
});

//Language functions 
updateSmartCartLanguage = async function() {
  const locale = Shopify?.locale;
  const translation = translations[locale]?.smart_cart;

  if (locale && translation) {
      Object.assign(Rebuy.SmartCart.settings.language, translation);
      if (translations[locale]?.announcement_bar) {
          Object.assign(Rebuy.SmartCart.settings.announcement_bar, translations[locale].announcement_bar);
      }
  }
};

updateWidgetLanguage = (widget) => {
const locale = Shopify?.locale;
const widgetTranslation = translations[locale]?.[widget.id];
const globalTranslation = translations[locale]?.widget;

if (locale && widgetTranslation) {
    Object.assign(widget.data.settings.language, widgetTranslation);
    widget.compileConfig();
} else if (locale && globalTranslation) {
    Object.assign(widget.data.settings.language, globalTranslation);
    widget.compileConfig();
}
};

updateRemaining = () => {
const locale = Shopify?.locale;
if (translations[locale]) {
    const remainingAmount = document.querySelector('.rebuy-cart__flyout-subtotal-label .item-count');
    if (remainingAmount) {
        remainingAmount.innerHTML = Rebuy.Cart.cart.item_count;
    }

    const tiers = Rebuy.SmartCart?.settings?.buy_more_save_more?.tiers;
    if (tiers) {
        tiers.forEach((tier, index) => {
            if (document.querySelectorAll('.rebuy-cart__flyout-item-buy-more-save-more-button').length > 0) {
                document.querySelectorAll('.rebuy-cart__flyout-item-buy-more-save-more-button .bmsm-discount')[
                    index
                ].innerHTML = tier.discount + '%';
                document.querySelectorAll('.rebuy-cart__flyout-item-buy-more-save-more-button .bmsm-quantity')[
                    index
                ].innerHTML = tier.quantity;
            }
        });
    }

    const bar = Rebuy.SmartCart.getCurrentTier(Rebuy.SmartCart?.progressBar);
    const barEl = document.getElementById('rebuy-cart__progress-bar-meter-label');
    const helperShipping = barEl.querySelector('.helper-shipping');
    const helperProduct = barEl.querySelector('.helper-product');
    if (bar && barEl) {
        if (bar.type === 'shipping') {
            if (!helperShipping) {
                barEl.innerHTML = translations[locale]?.smart_cart?.free_shipping_remaining;
            }
            barEl.querySelector('.helper-shipping').innerHTML = Rebuy.util.formatMoney(
                -Math.round(-bar.minimum * 100) - Rebuy.SmartCart.shippingExcludedSubtotal()
            );
        } else {
            if (!helperProduct) {
                barEl.innerHTML = translations[locale]?.smart_cart?.free_product_tier_remaining;
            }
            barEl.querySelector('.helper-amount').innerHTML = Rebuy.util.formatMoney(
                -Math.round(-bar.minimum * 100) - Rebuy.SmartCart.shippingExcludedSubtotal()
            );
            barEl.querySelector('.helper-product').innerHTML = bar.products[0].title ?? 'Free Product';
        }
    }
}
};
